import { ref, getCurrentInstance, onMounted, onBeforeUnmount } from "vue";
const useEl = () => {
  const el = ref();
  const { proxy } = getCurrentInstance();
  onMounted(() => {
    el.value = proxy == null ? void 0 : proxy.$el;
  });
  onBeforeUnmount(() => {
    el.value = void 0;
  });
  return el;
};
export {
  useEl as u
};
//# sourceMappingURL=useEl-3fe9f3d1.mjs.map
